import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap, withLatestFrom } from 'rxjs/operators';
import { extensionGroupRoute } from 'src/app/app-routing.module';
import { ConfirmationDialogService } from 'src/app/common-components/confirmation-dialog/confirmation-dialog.service';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { getSelectedAccountId } from 'src/app/store/select-account/select-account.selector';
import { ExtensionGroupDetailSaveModel } from '../../extension-group-details/models/extension-group-detail-save.model';
import { AddExtensionGroupApiService } from '../services/add-extension-group-api.service';
import * as AddExtensionGroupActions from './add-extension-group.actions';

@Injectable()
export class AddExtensionGroupEffects {
   createExtensionGroup$ = createEffect(() => {
      return this.actions$.pipe(
         ofType(AddExtensionGroupActions.createExtensionGroup),
         withLatestFrom(this.store.select(getSelectedAccountId)),
         switchMap(([action, accountId]) => {
            const extensionGroup: ExtensionGroupDetailSaveModel = {
               ...action.extensionGroupSave.extensionGroup,
               accountId: accountId,
            };
            return this.addExtensionGroupApiService
               .create(extensionGroup, action.extensionGroupSave.extensionGroupFields)
               .pipe(
                  map((executionResult) => {
                     return AddExtensionGroupActions.createExtensionGroupSuccess({
                        extensionGroupId: executionResult.data.extensionGroup.extensionGroupId,
                        name: executionResult.data.extensionGroup.name,
                     });
                  }),
                  catchError((error) => {
                     return of(AddExtensionGroupActions.createExtensionGroupFailure(error));
                  })
               );
         })
      );
   });

   createExtensionGroupSuccess$ = createEffect(
      () => {
         return this.actions$.pipe(
            ofType(AddExtensionGroupActions.createExtensionGroupSuccess),
            tap((result) => {
               this.dialogService.closeFormComponent();
               this.router.navigate([`/${extensionGroupRoute}/${result.extensionGroupId}`]);
               this.snackbar.open(`ExtensionGroup ${result.name} Created`);
            })
         );
      },
      {
         dispatch: false,
      }
   );

   constructor(
      private actions$: Actions,
      private addExtensionGroupApiService: AddExtensionGroupApiService,
      private store: Store,
      private snackbar: MatSnackBar,
      private dialogService: LcsDialogService,
      private confirmationService: ConfirmationDialogService,
      private router: Router
   ) {}
}
